import { graphql } from "relay-runtime"

export const deMedicationSearchQuery = graphql`
  query useDeMedicationSearchQuery($searchTerm: String!) {
    de_preparations(searchTerm: $searchTerm) {
      ... on SuccessPreparationResult {
        result {
          productId
          name
          composition
          isPrescriptionRequired
          pharmaceuticalCentralNumberList {
            name
            unit
            price
            quantity
            pharmaceuticalCentralNumber
          }
          pharmaceuticalForm {
            ifaCode
            name
          }
        }
      }
    }
    de_substances(searchTerm: $searchTerm) {
      ... on SuccessSubstanceResult {
        result {
          substanceId
          nameHtml
        }
      }
    }
  }
`
